<template>
  <layout-home>
    <transition appear name="fade-in">
      <Navigation />
    </transition>
    <div class="main__content">
      <div class="main__content-wrap">
        <!-- <Logo game="dos" /> -->
        <div class="main__buttons">
          <slide-in :delay="1200" class="button-wrap">
            <template v-if="launchableGame === 'dos'">
              <button-play @click="runGame" />
            </template>
            <template v-else>
              <button-get-game :href="getGameLink" />
            </template>
          </slide-in>
        </div>
      </div>
      <aside>
        <!-- <News :cache-version="cacheVersion" game="dos" /> -->
        <slide-in :delay="1600" direction="left">
          <Banner />
        </slide-in>
        <slide-in :delay="1700" direction="left">
          <MerchWidget :cache-version="cacheVersion" />
        </slide-in>
      </aside>
    </div>
  </layout-home>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import ClickOutside from "vue-click-outside";

import layoutHome from "@/layouts/layoutHome.vue";
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import Banner from "@/components/ui/Banner.vue";
import MerchWidget from "@/components/MerchWidget.vue";
import Logo from "@/components/ui/Logo.vue";
import Gamepad from "@/utils/gamepadInit";

export default {
  name: "DosHome",
  components: {
    layoutHome,
    Navigation,
    Banner,
    MerchWidget,
    Logo,
  },
  data() {
    return {
      settingsOpened: false,
    };
  },
  created() {
    // this.$store.dispatch("setGame", "dos");
    document.leaveWebView = this.leaveWebView;
  },
  computed: {
    ...mapState({
      system: (state) => state.system,
      cacheVersion: (state) => state.cacheVersion,
      launchableGame: (state) => state.launchableGame,
      platform: (state) => state.initPlatform,
    }),
    getGameLink() {
      if (this.platform === "steam") {
        return "https://store.steampowered.com/app/373420/Divinity_Original_Sin__Enhanced_Edition";
      }

      if (this.platform === "galaxy") {
        return "https://www.gog.com/game/divinity_original_sin_enhanced_edition";
      }

      return "http://www.divinityoriginalsin.com/";
    },
  },
  methods: {
    leaveWebView() {
      document.pad.leaveWebView();
    },
    async runGame() {
      await this.$store.dispatch("runGame");
    },
    toggleSettings() {
      if (this.settingsOpened) {
        this.settingsOpened = false;
      } else {
        this.settingsOpened = true;
      }
    },
  },
  mounted() {
    this.$store.dispatch("getVersion");
    Gamepad();
    this.$store.dispatch("webpageReady");
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
// ===================
//    animation
// ===================
.fade-in-enter {
  ::v-deep .navigation__wrap {
    opacity: 0;
    transform: translateY(-100%);
  }
  // transition-delay: 1000ms;
}

.fade-in-enter-to {
  ::v-deep .navigation__wrap {
    opacity: 1;
    transition: opacity 500ms ease, transform 500ms ease;
    transition-delay: 1200ms;
  }
}

// ===================
//    component
// ===================

.main {
  height: 100vh;
  position: relative;
  padding: 0 5vw;
  display: flex;
  flex-direction: column;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: -1;
  }

  &__content {
    height: 100%;
    display: flex;
    margin-top: 5vh;
  }

  &__content-wrap {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 50vw;
    margin-right: 5vw;
    margin-bottom: 13vh;
  }

  &__buttons {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    gap: 15px;

    .play-button {
      width: 100%;
    }

    .button-wrap {
      width: 100%;
    }
  }
}

aside {
  display: flex;
  flex-direction: column;
  margin-bottom: 4vh;
}
</style>
